import { ConvertStringToHtmlId } from '../../../../../libs/ts/ConvertStringToHtmlId';
import { useIsEnv } from '../../src/hooks/useIsEnv';
import type { ReactElement } from 'react';

export interface props {
  children: ReactElement[] | ReactElement;
  className?: string;
  identifier: string;
  render?: boolean;
}

export const Card = (props: props) => {
  const isDev = useIsEnv().isDev;

  if (props.render === false) {
    return <span className={`jbp-card-not-displayed-${ConvertStringToHtmlId(props.identifier)}`}></span>;
  }

  return (
    <div title={isDev ? 'DevInfo: Card' : ''} className={`jbp-card jbp-card-${ConvertStringToHtmlId(props.identifier)} ${props.className} bg-elevation-1 w-full`}>
      {props.children}
    </div>
  );
};
